var path = '/var/www/mmscny-website/src/app/common/app.html';
var html = "<div> <app-header features=$ctrl.features></app-header> <breadcrumb ng-hide=\"!$ctrl.hideShowAppNavComponents || $ctrl.hideBreadcrumb\"></breadcrumb> <div ui-view></div> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 features-description subscriber-form\" ng-hide=$ctrl.hideShowSubscribeComponent> <div class=container> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 feature no-padding\"> <div class=ctct-inline-form data-form-id=faf58575-ce0a-4e5f-9ab9-0f1615b16f6f></div> </div> </div> </div> <app-footer features=$ctrl.features ng-hide=!$ctrl.hideShowAppNavComponents></app-footer> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app.html
// module id = 641
// module chunks = 0